export default __webpack_public_path__ + "static/media/9.4efc46dc.png";